import { render } from "./DocumentDetails.vue?vue&type=template&id=4a1f6265&scoped=true&ts=true&lang=pug"
import script from "./DocumentDetails.vue?vue&type=script&lang=ts"
export * from "./DocumentDetails.vue?vue&type=script&lang=ts"

import "./DocumentDetails.vue?vue&type=style&index=0&id=4a1f6265&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a1f6265"]])

export default __exports__